import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPost,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { CommunityMemberSubscription } from "@/react/types/CommunityMemberSubscription";

interface IndexParams {
  filters?: Record<string, any>;
  order?: Record<string, "desc" | "asc">;
  page?: string | number;
  perPage?: number;
  searchKey?: string;
}

interface RefundOptionsParams {
  subscriptionProcessorId: string;
}

interface CreateParams {
  params: Record<string, any>;
}

interface CancelAndRefundParams {
  params: Record<string, any>;
  subscriptionProcessorId: string;
}

interface ResumeSubscriptionParams {
  subscriptionProcessorId: string;
}

const index = ({ filters, order, page, perPage, searchKey }: IndexParams) => {
  const searchKeyObject = searchKey ? { search_key: searchKey } : {};

  return () =>
    reactQueryGet(
      internalApi.admin.paywalls.subscriptions.index({
        params: {
          filters,
          order,
          page,
          per_page: perPage,
          ...searchKeyObject,
        },
      }),
    );
};

const refundOptionsSubscription = ({
  subscriptionProcessorId,
}: RefundOptionsParams) =>
  reactQueryGet(
    internalApi.admin.paywalls.subscriptions.refundOptions({
      subscriptionProcessorId,
    }),
  );

const create = ({ params }: CreateParams) =>
  reactQueryPost(internalApi.admin.paywalls.subscriptions.create(), params);

const cancelAndRefundSubscription = ({
  subscriptionProcessorId,
  params,
}: CancelAndRefundParams) =>
  reactQueryPost(
    internalApi.admin.paywalls.subscriptions.cancellations({
      subscriptionProcessorId,
    }),
    params,
  );

const resumeSubscription = ({
  subscriptionProcessorId,
}: ResumeSubscriptionParams): Promise<CommunityMemberSubscription> =>
  reactQueryDelete<CommunityMemberSubscription, object>(
    internalApi.admin.paywalls.subscriptions.cancellations({
      subscriptionProcessorId,
    }),
  );

export const paywallSubscriptionsApi = {
  index,
  create,
  cancelAndRefundSubscription,
  resumeSubscription,
  refundOptionsSubscription,
};
